import React from 'react';
import HoverIcon from 'components/HoverIcon';
import { Document, DocumentItem, DocumentName, Thumb } from './styles';
import unknown from 'assets/images/unknown.svg';
import { IDocumentView } from 'store/companies/companiesTypes';
import i18n, { languageDirection } from '../../../../i18n';

interface IDocumentsListItemProps {
  document: IDocumentView;
  deleteDocument: (type: string, companyId: number) => void;
  companyId: number;
}

const DocumentListItem: React.FC<IDocumentsListItemProps> = ({
  document,
  deleteDocument,
  companyId,
}) => {
  return (
    <DocumentItem>
      <Document>
        <Thumb src={document.thumbnailUrl || document.url || unknown} />
        <DocumentName>
          {i18n.t(document.properties.displayName, {
            ns: 'companyManagement',
          })}
        </DocumentName>
      </Document>
      <div>
        <div
          style={{ float: languageDirection() === 'rtl' ? 'left' : 'right' }}
        >
          <HoverIcon
            type="x"
            color="red"
            onClick={() =>
              deleteDocument(document.properties.displayName, companyId)
            }
          />
        </div>
      </div>
    </DocumentItem>
  );
};

export default DocumentListItem;
